import React, { useEffect, useState, useRef } from "react";
import {
  Box,
  Button,
  Card,
  Grid,
  Typography,
  TableContainer,
  DialogActions,
  TextField,
  Modal,
  Paper,
  IconButton,
  Dialog,
  DialogContent,
  CircularProgress,
  DialogTitle,
} from "@mui/material";
import { StyledSnackbar, StyledAlert } from "components/StyledComponents/styledComponents";
import VisibilityIcon from "@mui/icons-material/Visibility";
import { AgGridReact } from "ag-grid-react";
import PropTypes from "prop-types";
import "ag-grid-community/styles/ag-grid.css"; // Core grid CSS
import "ag-grid-community/styles/ag-theme-alpine.css";
import dayjs from "dayjs";
import { monthEndStyles } from "components/Styles/monthEndStyles";

import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import { StyledAgGridContainer } from "components/StyledComponents/styledComponents";
import URLs from "constants/urls";
import { StyledButton } from "components/StyledComponents/styledComponents";
import { StyledCancelButton } from "components/StyledComponents/styledComponents";

const LeadReports = () => {
  const [fromDate, setFromDate] = useState(dayjs().startOf("month").format("YYYY-MM-DD"));
  const [toDate, setToDate] = useState(dayjs().format("YYYY-MM-DD"));
  const [filteredLeadsList, setFilteredLeadsList] = useState([]);
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");
  const [alertType, setAlertType] = useState("success");
  const leadsGridRef = useRef(null);
  const [worklogData, setWorklogData] = useState([]);
  const [showWorklogPopup, setShowWorklogPopup] = useState(false);

  const setAlert = (msg, type) => {
    setMessage(msg);
    setAlertType(type);
    setOpen(true);
  };
  const handleClose = () => setOpen(false);
  const viewLeadWorklog = async (leadId) => {
    setLoading(true);
    try {
      const response = await fetch(`${URLs.leadGetByIdUrl}/${leadId}`);
      if (!response.ok) throw new Error("Failed to fetch lead worklog");

      const data = await response.json();

      const mapped = data.map((log) => ({
        LogBy: log.LogBy || "Unknown",
        LogDate: log.LogDate || "",
        Comments: log.Comments || "No Comments",
      }));

      setWorklogData(mapped);
      setShowWorklogPopup(true);
    } catch (error) {
      setAlert("Error fetching worklog:", error);
      setLoading(false);
    }
    setLoading(false);
  };

  // 🔁 Fetch All Leads
  const fetchLeadsList = async () => {
    setLoading(true);
    try {
      const response = await fetch(URLs.leadGetALLUrl, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          username: "",
        }),
      });
      if (!response.ok) throw new Error("Failed to fetch leads");

      const data = await response.json();

      setFilteredLeadsList(data);
    } catch (error) {
      setAlert("Error fetching leads:", error);
    }
    setLoading(false);
  };
  useEffect(() => {
    fetchLeadsList();
  }, []);
  const ActionCellRenderer = (props) => {
    return (
      <div style={{ display: "flex", gap: "10px", alignItems: "center", justifyContent: "center" }}>
        <IconButton onClick={() => viewLeadWorklog(props.data.LeadId)}>
          <VisibilityIcon fontSize="small" />
        </IconButton>
      </div>
    );
  };
  ActionCellRenderer.propTypes = {
    data: PropTypes.object.isRequired,
    context: PropTypes.shape({
      handleDateFetch: PropTypes.func.isRequired,
    }).isRequired,
  };

  // 📊 AG Grid Columns
  const columnDefsLeads = [
    { headerName: "Customer Name", field: "CustomerName", flex: 1 },
    { headerName: "Mobile Number", field: "MobileNumber", flex: 1 },
    { headerName: "Loan Amount", field: "LoanAmount", flex: 1 },
    { headerName: "Loan Type", field: "LoanType", flex: 1 },
    { headerName: "Occupation", field: "Occupation", flex: 1 },
    { headerName: "Reference", field: "Reference", flex: 1 },
    { headerName: "Address", field: "Address", flex: 1 },
    { headerName: "Lead Date", field: "LeadDate", flex: 1 },
    { headerName: "Last Visit Date", field: "LastVisitDate", flex: 1 },
    { headerName: "Next Visit Date", field: "NextVisitDate", flex: 1 },
    { headerName: "Created By", field: "CreatedBy", flex: 1 },
    {
      headerName: "Actions",
      field: "actions",
      flex: 1,
      cellRenderer: ActionCellRenderer,
    },
  ];

  const worklogColumnDefs = [
    { headerName: "Created By", field: "LogBy", width: 150 },
    {
      headerName: "Created Date",
      field: "LogDate",
      width: 200,
      valueFormatter: (params) => (params.value ? dayjs(params.value).format("DD-MMM-YYYY") : ""),
    },
    { headerName: "Comments", field: "Comments", flex: 1 },
  ];

  return (
    <DashboardLayout>
      <TableContainer component={Paper} sx={monthEndStyles.tableContainer}>
        <Box display="flex" justifyContent="space-between" alignItems="center">
          {/* <Grid container spacing={2} sx={{ mb: 2 }}>
            <Grid item xs={12} md={2}>
              <TextField
                type="date"
                label="From Date"
                fullWidth
                value={fromDate}
                onChange={(e) => setFromDate(e.target.value)}
                InputLabelProps={{ shrink: true }}
              />
            </Grid>
            <Grid item xs={12} md={2}>
              <TextField
                type="date"
                label="To Date"
                fullWidth
                value={toDate}
                onChange={(e) => setToDate(e.target.value)}
                InputLabelProps={{ shrink: true }}
              />
            </Grid>
            <Grid item xs={12} md={4} display="flex" alignItems="center">
              <StyledButton variant="contained" onClick={fetchLeadsList}>
                Submit
              </StyledButton>
            </Grid>
          </Grid> */}
          <Dialog
            open={showWorklogPopup}
            fullWidth
            maxWidth="lg"
            onClose={() => setShowWorklogPopup(false)}
          >
            <DialogTitle sx={{ bgcolor: "#ffffff", color: "#121212" }}>Work Logs</DialogTitle>

            <DialogContent sx={{ bgcolor: "#ffffff", color: "#121212" }}>
              <Typography variant="caption" sx={{ fontSize: "14px", display: "block", mb: 1 }}>
                View all work logs made by the executive on the selected date.
              </Typography>

              <Box
                className="ag-theme-alpine"
                sx={{
                  height: 350,
                  width: "100%",
                  borderRadius: 1,
                  overflow: "auto",
                }}
              >
                <div
                  className="ag-theme-alpine"
                  style={{ height: 330, width: "100%", marginTop: 8 }}
                >
                  <AgGridReact
                    enableCellTextSelection={true}
                    enableRangeSelection={true}
                    rowData={worklogData}
                    columnDefs={worklogColumnDefs}
                    defaultColDef={{
                      filter: true, // Enable filtering by default
                      sortable: true, // Optional: allow sorting too
                      resizable: true, // Optional: allow resizing columns
                      floatingFilter: true,
                    }}
                    pagination
                    paginationPageSize={5}
                  />
                </div>
              </Box>
            </DialogContent>

            <DialogActions>
              <StyledCancelButton
                onClick={() => setShowWorklogPopup(false)}
                color="error"
                variant="contained"
              >
                Cancel
              </StyledCancelButton>
            </DialogActions>
          </Dialog>
        </Box>
        <StyledAgGridContainer
          component={Paper}
          className={`ag-theme-alpine`}
          sx={{
            flexGrow: 1,
            height: "100%",
            width: "100%",
            display: "flex",
            flexDirection: "column",
            "& .ag-root-wrapper": {
              flex: 1,
              minHeight: 0,
            },
          }}
        >
          <AgGridReact
            enableCellTextSelection={true}
            enableRangeSelection={true}
            ref={leadsGridRef}
            rowData={filteredLeadsList}
            columnDefs={columnDefsLeads}
            frameworkComponents={{
              actionCellRenderer: ActionCellRenderer,
            }}
            defaultColDef={{
              filter: true, // Enable filtering by default
              sortable: true, // Optional: allow sorting too
              resizable: true, // Optional: allow resizing columns
              floatingFilter: true,
            }}
            pagination
            paginationPageSize={10}
          />
        </StyledAgGridContainer>
      </TableContainer>
      <Dialog
        open={loading}
        onClose={() => setLoading(false)}
        aria-labelledby="loading-dialog-title"
        sx={{
          "& .MuiDialog-paper": {
            padding: "clamp(10px, 2vw, 20px)",
            minWidth: "clamp(200px, 30vw, 300px)",
          },
        }}
      >
        <DialogContent
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            gap: "clamp(10px, 2vw, 20px)",
          }}
        >
          <CircularProgress color="primary" size="clamp(24px, 4vw, 40px)" />
          <Typography variant="h6" sx={{ fontSize: "clamp(14px, 2vw, 20px)" }}>
            Loading, please wait...
          </Typography>
        </DialogContent>
      </Dialog>
      <StyledSnackbar
        open={open}
        autoHideDuration={5000}
        onClose={handleClose}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
        severity={alertType}
        sx={{
          width: "clamp(250px, 50vw, 400px)",
          top: "clamp(10px, 2vh, 20px)",
        }}
      >
        <StyledAlert onClose={handleClose} severity={alertType}>
          {message}
        </StyledAlert>
      </StyledSnackbar>
    </DashboardLayout>
  );
};

export default LeadReports;
